import { ReactElement, useMemo } from 'react';
import { useTheme, Fade } from '@mui/material';

import { GlobalBannersBaseModalProps } from './types';
import { GlobalBannersModal, GlobalBannersModalBackDrop } from './styles';

const GlobalBannersModalBase = ({
  open,
  onClose,
  disableEscapeKeyDown = false,
  useCustomBackDrop = true,
  children,
}: GlobalBannersBaseModalProps): ReactElement => {
  const theme = useTheme();

  const transitionDuration = useMemo(
    () => ({
      enter: theme.transitions.duration.enteringScreen,
      exit: theme.transitions.duration.leavingScreen,
    }),
    [theme],
  );

  const BackdropComponent = useMemo(
    () => (useCustomBackDrop ? GlobalBannersModalBackDrop : undefined),
    [useCustomBackDrop],
  );

  return (
    <GlobalBannersModal
      open={open}
      onClose={onClose}
      closeAfterTransition
      disableEscapeKeyDown={disableEscapeKeyDown}
      BackdropComponent={BackdropComponent}
      BackdropProps={{ transitionDuration }}
    >
      <Fade
        appear
        in={open}
        timeout={transitionDuration}
        role="presentation"
        unmountOnExit
      >
        {children}
      </Fade>
    </GlobalBannersModal>
  );
};

export default GlobalBannersModalBase;
